<template>
  <v-card :color="background('color')" :min-height="$vuetify.breakpoint.height">
    <v-img :style="backgroundStyle()" :min-height="$vuetify.breakpoint.height">
      <CarouselBox class="mt-8" :items="carouselItems" :hideDelimiter="true" :fixHeight="carouselFixHeight" />
      <template v-for="(group, index) in Object.keys(appList)">
        <v-card
          v-if="appList[group].length != 0"
          class="ma-4"
          height="60"
          :style="customColor('groupColor')"
          :color="customColor('groupBackground')"
          :key="group"
        >
          <v-card-title>
            <v-row class="ma-0 text-h4" align="center" justify="center">{{ $t(group) }}</v-row>
          </v-card-title>
        </v-card>
        <v-row class="mx-8 my-8" v-if="appList[group].length != 0" :key="index">
          <v-col class="px-1 my-4" v-for="list in appList[group]" :key="list.name">
            <CardIntro
              class="mt-15"
              :data="list"
              :styleInfo="styleInfo"
              :key="list.name"
              @click="cardHandler(list.name)"
              @click.native="carouselHandler()"
            />
          </v-col>
        </v-row>
      </template>
    </v-img>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import CarouselBox from '@/components/CarouselBox.vue';
import CardIntro from '../components/CardIntro.vue';

export default {
  name: 'Custom3',
  props: {},
  components: { CarouselBox, CardIntro },
  data: () => ({
    group: ['newForMonth', 'hotSale'],
  }),
  computed: {
    ...mapState('dbTable', ['filterList', 'filterSubject', 'customList']),
    appList() {
      const list = { newForMonth: [], hotSale: [] };
      this.filterList.forEach((item) => {
        if (new Date(item.updateTime).getFullYear() === new Date().getFullYear() && new Date(item.updateTime).getMonth() === new Date().getMonth()) {
          list.newForMonth.push(item);
        } else {
          list.hotSale.push(item);
        }
      });
      return list;
    },
    styleInfo() {
      if (!this.filterSubject) return {};
      return this.customList.find((x) => x.id === this.filterSubject).styleInfo;
    },
    carouselFixHeight() {
      return this.styleInfo.boardHeight === '' ? 'auto' : this.styleInfo.boardHeight;
    },
    carouselItems() {
      if (!Object.prototype.hasOwnProperty.call(this.styleInfo, 'board')) return [];
      return this.styleInfo.board.map((x) => ({ src: `${process.env.VUE_APP_S3_URL}${x}` }));
    },
  },
  created() {
    if (!this.filterSubject) {
      this.$router.push({ name: 'main' });
    }
  },
  methods: {
    background(type) {
      if (!this.filterSubject || this.styleInfo.background.type !== type) return '';
      // if (this.styleInfo.background.type === 'image' && this.styleInfo.background.image === '') return './bg.jpg';
      return this.styleInfo.background.type === 'color'
        ? this.styleInfo.background.color
        : `${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image}`;
    },
    backgroundStyle() {
      if (!this.filterSubject || this.styleInfo.background.type !== 'image') return '';
      if (this.styleInfo.background.image === '') {
        return {
          backgroundImage: 'url(./bg.jpg)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'contain',
        };
      }
      return {
        backgroundImage: `url(${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image})`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'contain',
      };
    },
    customColor(type) {
      switch (type) {
        case 'groupBackground':
          return this.styleInfo[type];
        default:
          return `color: ${this.styleInfo[type]}`;
      }
    },
    carouselHandler() {
      if (Object.prototype.hasOwnProperty.call(this.styleInfo, 'boardHyperlink') && this.styleInfo.boardHyperlink !== '') {
        window.open(this.styleInfo.boardHyperlink);
      }
    },
    cardHandler(productName) {
      this.$router.push({ name: 'cardDetail', params: { productName } });
    },
  },
};
</script>
